
const UrlSegment = {
    url: 'Delivery'
};


export const DeliveryActionsPack = {

    Enviar: {
        verb: 'registrar el envío',
        icon: 'local_shipping',
        title: 'Enviar',
        btnTitle: 'Enviar',
        key: 3,


        body: {
            deliveryId: null
        },

        urlTarget: {
            type: 'query',


            getInit: function (body) {
                return `${UrlSegment.url}/Send/${body?.deliveryId}`
            }
        },
    },

    Contactar: {
        verb: 'contactar',
        icon: 'check_box',
        title: 'Contactar',
        btnTitle: 'Contactar',
        key: 4,

        body: {
            deliveryId: null
        },

        urlTarget: {
            type: 'query',


            getInit: function (body) {
                return `${UrlSegment.url}/ReachMember/${body?.deliveryId}`
            }
        },
    },

    Ver: {
        verb: 'Ver Usuario',
        icon: 'visibility',
        title: 'Ver usuario',
        key: 5
    },




};